import styled from 'styled-components';
export const Container = styled.div`
  padding : 20px 20px;
  background : white;
  display : flex;
  border-bottom : 1px solid #d2d2d2;
  justify-content : center;
  align-items : center;
  flex-direction : ${props => props.column ? "column" : "row"};
`;

export const Div = styled.div`
  display : flex;
  flex-direction : ${props => props.column ? "column" : "row"};
  margin : ${props => props.margin ? props.margin : "0"};
  justify-content : ${props => props.justifyContent ? props.justifyContent : "space-between"};
  align-items : ${props => props.alignItems ? props.alignItems : 'center'};
  flex : ${props => props.flex ? props.flex : ""};
  width : ${props => props.width ? props.width : "100%"};
`;

export const Title = styled.div`
  width: 100%;
  font-size : 16px;
  font-weight : 600;
  text-align : left;
  white-space:nowrap;
  overflow: hidden;
  margin-bottom: 2px;
`;

export const NickNamePannel = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: white;
  cursor: pointer;
  border-radius: 20px 20px;

  img {
    cursor: pointer;
  }

  :nth-child(3) {
    width: 30px;
    height: 30px;
  }
`;

export const NickName = styled.div`
  font-size :15px;
  font-weight :600;
  margin-left: 5px;
  cursor: pointer;
  text-decoration: none;
  text-align: center;
  max-width: 140px;
  overflow: hidden;
  :hover {
    text-decoration: underline;
  }
  :hover:before {
    text-decoration: none;
  }
`;

export const CountDiv = styled.div`
  display :flex;
  margin : ${props => props.margin ? props.margin : "0"};
  align-items : center;
  >span{
      margin : 0px 5px;
      cursor: ${props => props.cursor ? "pointer" : ""}
  }
`;

export const Count = styled.div`
  margin: 0 5px;
  font-weight : 600;
  font-size : 15px;
`;

export const Img = styled.img`
  cursor :pointer;
  width: 18px;
  height: 18px;
  margin : ${props => props.margin ? props.margin : "0"};
`;

export const ProfileImg = styled.img`
  width: 36px;
  height: 36px;
  background-color: #FFF;
  border-radius: 50px;
  border : 0.5px solid #eeeeee;
  margin: 0 5px 5px 0;
  object-fit: cover;
`;